module.exports = __webpack_public_path__ + "img/subject.17764d94.svg";